define('app/sdc/custom/sdc-custom',[], function () {
	return {
		restrict: "A",
		require: {
			"ngModel": "?ngModel"
		},
		scope: false,
		link: ["$scope", "$attrs", "$controllers", function ($scope, $attrs, $controllers) {
			if (!$controllers.ngModel) {
				return;
			}
			var removeLastWatch = angular.noop;
			$attrs.$observe("sdcCustom", function (customExpr) {
				removeLastWatch();
				removeLastWatch = $scope.$watchCollection(customExpr, function (validators) {

				});
			});
		}]
	}
});
